<script setup>
import { ref, onMounted, onBeforeUnmount, nextTick, computed } from 'vue'
import CartPaymentScreenInfoBlock from '../CartPaymentScreenInfoBlock.vue'
import CartBusinessDetails from '../CartBusinessDetails.vue'
import CartBusinessDetailsFilingStatus from '../CartBusinessDetailsFilingStatus.vue'
import BAccordion from '../bootstrap/BAccordion.vue'
import BAccordionItem from '../bootstrap/BAccordionItem.vue'
import TheAlert from '../TheAlert.vue'
import RatingCard from './RatingCard.vue'
import { useCartStore } from '../../stores/cartStore'
import { useUserStore } from '../../stores/userStore'
import CartStepBusinessCardWrapper from '../CartStepBusinessCardWrapper.vue'
import CartStepCardForm from '../CartStepCardForm.vue'
import BusinessCardComponent from './BusinessCardComponent.vue'
import BusinessCardStaticWrapper from './BusinessCardStaticWrapper.vue'
import CartLoginOrFilings from '../CartLoginOrFilings.vue'

const props = defineProps({
  cartData: Object,
  cartSlug: String,
  company_uuid: {
    type: String,
    default: null,
    required: false
  }
})

const cartStore = useCartStore()
const userStore = useUserStore()
// A ref of the business card wrapper component that we use to
// toggle collapse from the parent component
const businessCard = ref(null)

const stickyOptions = ref({
  parentSelector: '#stickyBusinessStartPoint',
  targetSelector: '#header',
  startPoint: '#stickyBusinessStartPoint',
  endPoint: '#stickyBusinessEndPoint',
  breakpoint: 'md',
  stickyOffsetTop: 20,
  onSticky: (isSticky) => {
    if (businessCard.value) {
      businessCard.value.toggleCollapse(!isSticky)
    }
  }
})

const cartStep = computed(() => cartStore.cartData?.cartSteps[0] || {})

const showLoginOrFilingsInHero = computed(() => {
  return cartStore.subscriptionStatus?.active
})

const showLoginOrFilingsAboveHero = computed(() => {
  return userStore.isAuthenticated && !cartStore.subscriptionStatus?.active
})
</script>

<template>
  <div class="row justify-content-lg-between mb-md-10 mb-0">
    <CartLoginOrFilings v-if="showLoginOrFilingsAboveHero" />
    <div class="col-md-7 col-lg-7">
      <div class="row mb-0">
        <div class="mb-2">
          <h1 class="h1">
            {{ cartData?.title }}
          </h1>
          <p class="lead">
            {{ cartData?.subtitle }}
          </p>
          <TheAlert
            v-if="cartStore.cartData.cartConfig.urgencyBanner"
            :content="cartStore.cartData.cartConfig.urgencyBanner"
          />
        </div>
      </div>
      <div class="row d-none d-md-flex">
        <div class="col-12">
          <h5>
            We file the necessary documents and reports to keep you compliant.
            In just a few minutes, you can:
          </h5>
          <ul class="list-checked list-checked-primary mb-5">
            <li class="list-checked-item">
              Satisfy a new filing required by the Federal Government
            </li>
            <li class="list-checked-item">Avoid up to $500/day in fines</li>
            <li class="list-checked-item">
              Protect your business' good standing
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="col d-md-block">
      <div id="stickyBusinessStartPoint">
        <!-- Card -->

        <CartLoginOrFilings id="sticky-card" v-if="showLoginOrFilingsInHero" />
        <CartStepBusinessCardWrapper
          id="sticky"
          :cartData="cartStore.cartData"
          ref="businessCard"
          v-if="!showLoginOrFilingsInHero"
        >
          <CartStepCardForm :formMetadata="cartStep.formMetadata[0]" />
        </CartStepBusinessCardWrapper>

        <!-- End Card -->
      </div>
    </div>
    <div class="row d-block d-md-none mt-5 mb-0 pb-0">
      <div class="col-12 text-center">
        <h4 class="h4 mb-3">
          We file the necessary documents and reports to keep you compliant.
        </h4>
        <ul class="list-checked list-checked-primary mb-5 text-start">
          <li class="list-checked-item">
            Satisfy a new filing required by the Federal Government
          </li>
          <li class="list-checked-item">Avoid up to $500/day in fines</li>
          <li class="list-checked-item">
            Protect your business' good standing
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
